export const SET_ACTIVE_ROOM_CLASS = 'SET_ACTIVE_ROOM_CLASS';
export const RESET_ACTIVE_ROOM_CLASS = 'RESET_ACTIVE_ROOM_CLASS';

export const selectedRoomClass = (activeRoomClass) => ({
  type: SET_ACTIVE_ROOM_CLASS,
  payload: activeRoomClass,
});

export const resetRoomClass = () => ({
  type: RESET_ACTIVE_ROOM_CLASS,
});

export default function setActiveRoomClass(activeRoomClass) {
  return (dispatch) => {
    dispatch(selectedRoomClass(activeRoomClass));
  };
}

export function resetActiveRoomClass() {
  return (dispatch) => {
    dispatch(resetRoomClass());
  };
}



// WEBPACK FOOTER //
// ./src/actions/setActiveRoomClassActions.js